<template>
  <div class="flex justify-start items-center pb-4">
      <div class="mr-4">
          <slot></slot>
      </div>
      <div class="text-gray-1 text-22">
          {{ showDetail() }}
      </div>
  </div>
</template>

<script>
export default {
    name: 'ProfileItem',
    props: {
        detail: { required: true },
        IsThaiID: { type: Boolean, required: false },
    },
    methods: {
        showDetail: function () {
            if (this.IsThaiID && this.detail != '') {
                let thaiId = this.detail.substring(0, 9);
                return thaiId + 'xxxx'
            } else {
                return this.detail;
            }
      },
    }
}
</script>

